export default "__VITE_ASSET__$OdHjhfY__"